import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import useXeroApi from "../../hooks/useXeroApi";
import Style from "./modal.module.scss";
import { buttonName, invcsConnect, responseStatus } from "../../locales/en";
import CommonModal from "./CommonModal";
import { INVOICE } from "../../route/paths";
import privateAxios from "../../utils/axiosPrivate";
import { getXeroAcceptCreditConcentUrl } from "../../utils/constants/apiEndPoints";
import { showToast } from "../../utils/utils";
export const XeroModal = ({ isOpen, toggle }) => {
  const navigate = useNavigate();
  const { XeroAuthorize } = useXeroApi();

  const handleXeroClick = async () => {
    try {
      const response = await XeroAuthorize();
      const redirectUrl = response?.data?.data?.authorizationUrl;
      if (redirectUrl != null) {
        window.location.href = redirectUrl;
      } else {
        navigate(INVOICE);
      }
    } catch {
      // handle error here
    }
  };

  const handleClickCreditConsent = async () => {
    try {
      const response = await privateAxios.post(getXeroAcceptCreditConcentUrl, {
        params: { acceptConsent: true }
      });
      handleXeroClick();
      showToast(response?.data?.message, responseStatus?.success);
    } catch (error) {
      showToast(
        error?.response?.data?.message || responseStatus?.errorText,
        responseStatus?.error
      );
    }
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={invcsConnect?.xeroModal.title}
      modalClassName={`${Style.xeroModal} modal-lg`}
      headerClassName={Style.xeroModalHeader}
      bodyClassName={Style.ppsrdetailsModalBody}
      footerClassName={Style.xeroModalFooter}
      footerButtons={[
        {
          label: buttonName.agree,
          className: "btn btn-primary",
          onClick: handleClickCreditConsent
        }
      ]}
    >
      <div className={`${Style.xeroModalContent} modal-content`}>
        <p className="mt-2">{invcsConnect?.xeroModal.text1}</p>
        <p className="mt-2">{invcsConnect?.xeroModal.text2}</p>
        <p className="mt-2">{invcsConnect?.xeroModal.text3}</p>
      </div>
    </CommonModal>
  );
};

XeroModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};
